export enum InvitationType {
  SYSTEM = 'system',
  PRODUCT = 'product',
  GROUP = 'group',
}
